<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})

//const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <div>
    <h2>Error: {{ error?.statusCode ?? 'unknown' }}</h2>
    <pre>
      {{ error }}
    </pre>
  </div>
</template>
